import { render, staticRenderFns } from "./DashboardBox.vue?vue&type=template&id=3a5160a0&scoped=true&"
import script from "./DashboardBox.vue?vue&type=script&lang=ts&"
export * from "./DashboardBox.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardBox.vue?vue&type=style&index=0&id=3a5160a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5160a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VIcon,VSpacer})
